module.exports = __webpack_public_path__ + "img/01.3b0b9165.png";